import { ReactNode, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

type RedirectResponse = {
  redirect_in: number;
  redirect_to: string;
};

export default function Success(): ReactNode {
  const [searchParams] = useSearchParams();
  const [redirect, setRedirect] = useState<RedirectResponse | undefined>();

  const email = searchParams.get("email");
  const orderId = searchParams.get("order_id");
  const orderKey = searchParams.get("order_key");

  useEffect(() => {
    let apiUrl = "api/location/hasRedirect/success";
    const query = [];

    if (orderId) query.push(`order_id=${orderId}`);
    if (orderKey) query.push(`order_key=${orderKey}`);

    if (query.length > 0) apiUrl = `${apiUrl}?${query.join("&")}`;

    fetch(apiUrl).then(async (resp) => {
      if (resp.status >= 400) {
        return;
      }

      const data = (await resp.json()) as RedirectResponse;

      if (!data.redirect_to) return;

      setRedirect(data);
      setTimeout(function () {
        window.location.href = data.redirect_to;
      }, data.redirect_in * 1000);
    });
  }, []);

  return (
    <div className="flex flex-col place-items-center gap-5 text-center">
      <div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="86"
          height="86"
          fill="#1DB578"
          className="bi bi-check-circle"
          viewBox="0 0 16 16"
        >
          <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
          <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z" />
        </svg>
      </div>

      <div className="text-wrap text-zinc-400">
        <h4 className="mb-3 mt-4 font-bold" style={{ color: "#1DB578" }}>
          Payment successful!
        </h4>

        <p className="mb-10">Thank you for your payment.</p>

        <p>
          An order confirmation email will be sent to your registered email.
        </p>
        <p>
          Please check your spam folder if you don't see the email in your
          inbox.
        </p>

        {redirect && (
          <>
            <p className="break-all">
              You're going to be redirected to {redirect.redirect_to} in{" "}
              {redirect.redirect_in} seconds.
            </p>

            {email && <p>Email: {email}</p>}

            {orderId && <p>Order ID: {orderId}</p>}
          </>
        )}
      </div>
    </div>
  );
}
